import React from 'react';
import ResultsWorkOrders from '../../results/results-work-orders';
import { APPS, COUNTS } from 'components/constants';
import { Expanding } from 'components/common/expanding';
import { WidgetTask } from 'components/dashboard/widget-task';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function WorkOrdersTasks(props) {

	const params = useParams();
    const counts = useSelector((store) => store.admin.dashboard_counts);

    return (
		<div className="row mb-2 no-gutters results" >

			{/* TASKS ------------------------------------------------------------------------------------- */}

			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'unassigned-wo' }
					badge={ (params.appId == APPS.ASSETS.id) ? counts?.[COUNTS.ASSETS_WORKORDERS_UNASSIGNED.id] ?? 0 : counts?.[COUNTS.SERVICE_WORKORDERS_UNASSIGNED.id] ?? 0 }
					icon={ <i className="fa-duotone fa-solid fa-file-xmark fa-3x"></i> }
					text={ 'Unassigned Work Orders' }
					value="unassigned-wo"
					onClick={ props.handleClick }
				/>
			</div>
			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'inprogress-wo' }
					badge={ (params.appId == APPS.ASSETS.id) ? counts?.[COUNTS.ASSETS_WORKORDERS_INPROGRESS.id] ?? 0 : counts?.[COUNTS.SERVICE_WORKORDERS_INPROGRESS.id] ?? 0 }
					icon={ <i className="fa-duotone fa-solid fa-rotate fa-3x"></i> }
					text={ 'Work Orders in Progress' }
					value="inprogress-wo"
					onClick={ props.handleClick }
				/>
			</div>
			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'incomplete-wo' }
					badge={ (params.appId == APPS.ASSETS.id) ? counts?.[COUNTS.ASSETS_WORKORDERS_INCOMPLETE.id] ?? 0 : counts?.[COUNTS.SERVICE_WORKORDERS_INCOMPLETE.id] ?? 0 }
					icon={ <i className="fa-duotone fa-solid fa-file-exclamation fa-3x"></i> }
					text={ 'Incomplete Work Orders' }
					value="incomplete-wo"
					onClick={ props.handleClick }
				/>
			</div>

			{/* RESULTS TABLES ---------------------------------------------------------------------------- */}

			<Expanding open={ params.widget_id == 'unassigned-wo' }>
				<ResultsWorkOrders />
			</Expanding>
			<Expanding open={ params.widget_id == 'inprogress-wo' }>
				<ResultsWorkOrders />
			</Expanding>
			<Expanding open={ params.widget_id == 'incomplete-wo' }>
				<ResultsWorkOrders />
			</Expanding>
		</div>
	);
};
